import React from 'react';
import styled from 'styled-components';

import { Bubble } from '@lt/components';
import { QuestionTip } from '@lt/components/icons-react';

interface LabelWithDescriptionProps {
  icon?: React.ReactNode;
  text?: string;
  tooltipTitle?: string;
  tooltipExtra?: string;
  flightNumber?: string;
  flightClassText?: string;
}
/**
 * Компонент для отображения плашек в нижней части перелета
 */
export const LabelWithDescription = ({
  icon,
  text,
  tooltipTitle,
  tooltipExtra,
  flightNumber,
  flightClassText,
}: LabelWithDescriptionProps): JSX.Element => (
  <Bubble
    title={
      tooltipTitle ? <TooltipTitle>{tooltipTitle}</TooltipTitle> : undefined
    }
    renderExtras={
      tooltipExtra
        ? () => <TooltipExtra>{tooltipExtra}</TooltipExtra>
        : undefined
    }
    closeable={false}
  >
    <Container>
      {icon ? <Icon>{icon}</Icon> : null}
      <StyledTooltipAndTextContainer>
        {text ? (
          <StyledTextContainer>
            <Text>{text}</Text>
            {flightNumber && (
              <StyledFlightNumber>
                {flightNumber.split(' ').join('-')}
                {flightClassText && (
                  <>
                    {', '}
                    {flightClassText}
                  </>
                )}
              </StyledFlightNumber>
            )}
          </StyledTextContainer>
        ) : null}

        {tooltipTitle && tooltipExtra && (
          <TooltipWrapper>
            <QuestionTipIcon />
          </TooltipWrapper>
        )}
      </StyledTooltipAndTextContainer>
    </Container>
  </Bubble>
);

const Container = styled.span`
  display: flex;
  flex-direction: row;
  gap: 6px;

  align-items: center;
  height: 24px;
`;

const StyledTooltipAndTextContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
`;

const StyledTextContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

const Text = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`;

const Icon = styled.span`
  height: 100%;
`;

const StyledFlightNumber = styled.span`
  font-size: 12px;
`;

const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
`;

const QuestionTipIcon = styled(QuestionTip)`
  height: 14px;
`;

const TooltipTitle = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: #17181a;
`;

const TooltipExtra = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #17181a;
`;
